__turbopack_context__.v({
  "active": "Tick-module__bcrs0q__active",
  "cardinal": "Tick-module__bcrs0q__cardinal",
  "intercardinal": "Tick-module__bcrs0q__intercardinal",
  "tick": "Tick-module__bcrs0q__tick",
  "tickIndicator": "Tick-module__bcrs0q__tickIndicator",
  "tickLabel": "Tick-module__bcrs0q__tickLabel",
});
